/** getters.js
 * vuexにおける、state を加工した状態で参照したい時に用いる00
 * ヘルパー関数などもここにある。
 */

import T from '@/modules/time'

export default {
  classroomNames: (state) => {
    return state.classrooms.map((x) => {
      return x.name
    })
  },
  edgeClassrooms: (state) => {
    return state.classrooms.filter((elem, index, self) => {
      if (index < self.length - 1) {
        return self[index].name.slice(0, 3) !== self[index + 1].name.slice(0, 3)
      }
    })
  },
  timelinesWidth: (state) => {
    return state.columnWidth * state.classrooms.length
  },
  timelineHeight: (state) => {
    return state.rowHeight * state.timeScaleTicks.length
  },
  tableWidth: (state, getters) => {
    return state.rulerWidth + getters.timelinesWidth
  },
  /** classroomの左端座標を返す
   * @arg {String} classroom - 左端座標を取得したい教室名
   * @return {Number} left - 左端の(相対)座標
   */
  getLeftPosOfClassroom: (state, getters) => (classroom) => {
    return getters.classroomNames.indexOf(classroom) * state.columnWidth
  },
  /** タイムライン上の座標における教室名を返す。
   * @arg {Number} pos - タイムライン上の座標
   * @return {String} classroom - 座標に対応する教室名
   */
  getClassroomAt: (state, getters) => (pos) => {
    const index = Math.floor(pos / state.columnWidth)
    return getters.classroomNames[index]
  },
  /** タイムライン上の座標に対応する時間オブジェクトを返す
  * @arg {Number} point - timelineのtopを原点とした、対象のy座標
  * @return {Object} time - timeオブジェクト( modules/time )
  */
  positionToTime: (state) => (point) => {
    // 1px あたりの時間 (30分区切り / rowHeight)
    const rate = 30 / state.rowHeight
    // 表の記載上の開始時刻
    const offsetTime = new T(state.timeScaleTicks[0])
    const t = offsetTime.addMinuites(Math.floor(rate * point))
    return t
  },
  /** 時刻に対してタイムライン上の座標を返す
   * @arg {String} time - 時間の文字列表示
   * @return {Number} point - タイムライン上の y 座標
   */
  timeToPosition: (state) => (time) => {
    // 1min.あたりのピクセル数
    const rate = state.rowHeight / 30
    const t = new T(time)
    const offsetTime = new T(state.timeScaleTicks[0])
    const diffedMins = t.decresaseMinuites(offsetTime.getMinutes()).getMinutes()
    const pixs = Math.floor(rate * diffedMins)
    return pixs
  },
  /** 最も近い区切り(10分など)の時刻を得る
   * @arg {Object} time - フィットしたい時刻オブジェクト @see {time.js}
   * @return {Object} resultTime - フィットされた時刻のオブジェクト
   */
  fitToNearDivTime: (state) => (time) => {
    const t = new T(time.toString())
    const mins = t.getMinutes()
    const offset = mins % state.timeDivMin
    if (offset < state.timeDivMin / 2) {
      return t.decresaseMinuites(offset)
    } else {
      return t.decresaseMinuites(offset)
        .addMinuites(state.timeDivMin)
    }
  },
  /** previewBox オブジェクトを得る */
  previewBox: (state) => {
    return state.previewBox
  },
  /** テーブルが参照している日付を特定のフォーマットの文字列にして返す
   * @return {String} formatted string
   */
  getCurDateFormated: (state) => {
    let day = state.curDate.getDate()
    // Date.monthは0から始まることに注意
    let month = state.curDate.getMonth() + 1
    const year = state.curDate.getFullYear()
    if (day < 10) {
      day = '0' + day
    }
    if (month < 10) {
      month = '0' + month
    }
    return '' + year + '-' + month + '-' + day
  },
  isLoggedIn: (state) => state.isLoggedIn,
  /**
   * start から end （時刻の文字表現) の間に， userIdが関与する予約のリスト を取得
   */
  reservationsInRange: (state) => (start, end) => {
    let startT = new T(start)
    let endT = new T(end)
    return state.reservations.filter((elem, index, self) => {
      let elemStartTime = new T(elem.start_time)
      let elemEndTime = new T(elem.end_time)
      return startT.getMinutes() < elemEndTime.getMinutes() &&
      startT.getMinutes() >= elemStartTime.getMinutes() ||
      endT.getMinutes() <= elemEndTime.getMinutes() &&
      endT.getMinutes() > elemStartTime.getMinutes() ||
      startT.getMinutes() < elemStartTime.getMinutes() &&
      endT.getMinutes() > elemEndTime.getMinutes()
    })
  },
  teacherList: (state) => {
    return state.userlist.filter((user, index, array) => {
      return user.user_type === 'teacher'
    })
  },
  studentList: (state) => {
    return state.userlist.filter((user, index, array) => {
      return user.user_type === 'student'
    })
  },
  sortedLectureList (state) {
    return state.lectureInfo.sort(
      (a, b) => {
        // console.log(a)
        if (a.teacher.id < b.teacher.id) {
          return -1
        } else if (a.teacher.id > b.teacher.id) {
          return 1
        } else if (a.student.id < b.student.id) {
          return -1
        } else if (a.student.id > b.student.id) {
          return 1
        } else {
          return 0
        }
      }
    )
  },
  school_id: (state) => {
    return state.userInfo.school_id
  }
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js